/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import {
  DEFAULT_TRANSLATION_LANGUAGES,
  LocalStorageLanguageProperty,
} from "../entities/Language";
import { LocalStorageService } from "../services/LocalStorageService";

const showTranslationDoesNotExist = (isPlaceholder: boolean) => {
  if (isPlaceholder) {
    return "Translation does not exist in DB!";
  }

  return (
    <span className="no-translation">Translation does not exist in DB!</span>
  );
};

const getValueFromObject = (
  object: { [K: string]: {} },
  key: string,
): string | null => {
  const keyInTheArrayForm = key.split(".");
  let extractedTranslation: string = "";
  let translationValue = object;

  for (const key of keyInTheArrayForm) {
    if (translationValue) {
      translationValue = translationValue[key];
    }
    if (typeof translationValue === "string") {
      extractedTranslation = translationValue;
    }
  }
  return extractedTranslation ? extractedTranslation : null;
};

const replaceVariablesWithValues = (
  value: string,
  variables: { [key: string]: string },
) => {
  let output = value;
  for (const [key, value] of Object.entries(variables)) {
    output = output.replaceAll(`{{${key}}}`, value);
  }
  return output;
};

export const getValueForKey = (
  translations: any,
  key: string,
  variables?: { [key: string]: string },
  isPlaceholder: boolean = false,
): any => {
  if (translations) {
    const languageFromStorage = LocalStorageService.getItem(
      LocalStorageLanguageProperty.LANGUAGE,
    );
    const selectedLanguage: string = languageFromStorage
      ? languageFromStorage.toUpperCase()
      : DEFAULT_TRANSLATION_LANGUAGES.DEFAULT;

    const selectedObject = translations[selectedLanguage];

    const value = getValueFromObject(selectedObject, key);

    // Check if values do not exist and the selected language is US or GB
    if (
      !value &&
      Object.values(DEFAULT_TRANSLATION_LANGUAGES).includes(
        selectedLanguage as DEFAULT_TRANSLATION_LANGUAGES,
      )
    ) {
      const defaultValue = getValueFromObject(
        translations[DEFAULT_TRANSLATION_LANGUAGES.DEFAULT],
        key,
      );
      // Check if the variables were provided
      if (variables && Object.keys(variables).length && defaultValue) {
        return replaceVariablesWithValues(defaultValue, variables);
      }

      // Check if this translation exists in default translations
      if (defaultValue) return defaultValue;

      return showTranslationDoesNotExist(isPlaceholder);
    }

    // Check if the variables were provided for selected language
    if (variables && Object.keys(variables).length && value) {
      return replaceVariablesWithValues(value, variables);
    }

    if (value) return value;

    return showTranslationDoesNotExist(isPlaceholder);
  }
};
